import { getMonthText } from "./getMonthText";

/**
 * 
 * @param {string} language Language
 * @param {string} year Year
 * @param {string} month Month
 * @returns Final string for any dates
 */
export function getDateString(language, year, month) {
  let dateString = language === "en" ? "Date: " : "Fecha: ";
  try {
    if (month)
      dateString = dateString + getMonthText(month, language, false) + ", ";

    dateString = dateString + year;
  } catch (error) {
    dateString = dateString + "---";
  }

  return dateString;
}
